import React from 'react';
import {
  Container,
  Flex,
  Text,
  Stack,
  Heading,
  Image,
  UnorderedList,
  ListItem
} from '@chakra-ui/react';
import { COLORS } from "../../../colors";

const Section = ({ imageSrcs, title, description, listItems, imageOnRight }) => {
  return (
    <Stack direction={{ base: 'column', md: 'row' }} fontFamily={"Montserrat"} spacing={10}>
      <Flex
        p={8}
        flex={1}
        align={'top'}
        justify={'center'}
        order={{ base: 1, md: imageOnRight ? 2 : 1 }}
      >
        <Stack spacing={6} w={'full'} maxW={'lg'} vertical-align={'top'}>
          <Heading textAlign={"center"} as="h2" size="xl" mt={0} mb={2} fontFamily={"Montserrat"} color={COLORS.brand1}>
            {title}
          </Heading>
          <Text textAlign={"center"} fontSize={{ base: 'md', lg: 'lg' }} color={'gray.500'}>
            {description}
          </Text>
          {listItems && (
            <UnorderedList textAlign={"center"} fontSize={{ base: 'md', lg: 'lg' }} color={'gray.500'}>
              {listItems.map((item, index) => (
                <ListItem key={index}>{item}</ListItem>
              ))}
            </UnorderedList>
          )}
        </Stack>
      </Flex>
      <Flex
        flexDirection='column'
        flex={1}
        order={{ base: 2, md: imageOnRight ? 1 : 2 }}
      >
        {imageSrcs.map((src, index) => (
          <Image
            key={index}
            alt={'Section Image'}
            objectFit={'cover'}
            src={src}
            maxH={{ base: '400px', md: '400px' }} // Ajusta esta altura según lo deseado
            w={'100%'}
            mb={0} // Margin bottom for spacing between images
          />
        ))}
      </Flex>
    </Stack>
  );
};

const Ket = () => {
  return (
    <Section
      imageSrcs={["/ket.jpg"]}
      title="KET"
      description="El objetivo principal es que los alumnos puedan realmente comunicarse en inglés con una buena pronunciación y tener la confianza de utilizar el inglés de una forma efectiva y a su vez complementar y enriquecer el inglés ya aprendido."
      imageOnRight={false}
    />
  );
};

const Pet = () => {
  return (
    <Section
      imageSrcs={["/pet.jpg"]}
      title="PET"
      description="El objetivo principal de nuestros cursos para este nivel están basados en el trabajo de todas las destrezas requeridas en los exámenes oficiales:"
      listItems={[
        "COMPRENSIÓN ORAL - LISTENING",
        "COMPRENSIÓN ESCRITA - READING",
        "EXPRESIÓN ORAL - SPEAKING",
        "EXPRESIÓN ESCRITA - WRITING"
      ]}
      imageOnRight={true}
    />
  );
};

const Fce = () => {
  return (
    <Section
      imageSrcs={["/fce.jpg"]}
      title="FCE"
      description="Los cursos de inglés de este nivel están diseñados para que los alumnos adquieran la capacidad de conversar, leer y escribir correctamente en inglés. Profundizan, perfeccionan y consolidan la lengua. Los estudiantes trabajan individualmente, por parejas o en pequeños grupos, y participan en conversaciones, juegos de rol, debates y presentaciones, entre otras actividades."
      imageOnRight={false}
    />
  );
};

const C1 = () => {
    return (
      <Section
        imageSrcs={["/c1.jpg"]}
        title="NIVEL C1"
        description="Este curso está diseñado para estudiantes que desean alcanzar un nivel avanzado de competencia en inglés. A lo largo del programa, los participantes mejorarán su capacidad para comprender y expresar ideas complejas en inglés, tanto de forma oral como escrita. Se trabajarán habilidades avanzadas de lectura y comprensión auditiva, permitiendo a los estudiantes abordar textos y discursos especializados con confianza."
        imageOnRight={true}
      />
    );
  };

const EsoBachiller = () => {
  return (
    
      <Stack direction="column" fontFamily={"Montserrat"} spacing={10}>
        <Ket />
        <Pet />
        <Fce />
        <C1/>
      </Stack>
  
  );
};



export default EsoBachiller;
